import { API_BASE_URL, ApiEnvelope, MediaTicket, apiClient, authHeaders } from 'service/apiClient';

const pdfViewerApi = {
  createMediaTicket(path: string) {
    return apiClient.post<ApiEnvelope<MediaTicket>>('/api/files/media-ticket', { path }, authHeaders());
  },

  revokeMediaTicket(ticket: string) {
    return apiClient
      .delete('/api/files/media-ticket', { params: { ticket }, ...authHeaders() })
      .catch(() => undefined);
  },

  filesStreamUrl(ticket: string) {
    return `${API_BASE_URL}/api/files/stream?${new URLSearchParams({ ticket })}`;
  },
};

export default pdfViewerApi;
